/* Vearo – shop grid: add to cart from the card, then show a quantity stepper that mirrors the cart. */
(function () {
  if (window.vearoQuickAddBound) return;
  window.vearoQuickAddBound = true;

  var SOURCE = 'vearo-quick-add';
  var BUBBLE_SECTION = 'cart-icon-bubble';
  var STEP_DELAY = 250;
  var cartState = null;
  /* Quantities the shopper has asked for that the cart has not confirmed yet, by variant id. */
  var pending = new Map();
  var queue = Promise.resolve();

  function fetchCart() {
    return fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        cartState = cart;
        sync();
        return cart;
      })
      .catch(function (error) {
        console.error(error);
        if (!cartState) cartState = { items: [], item_count: 0 };
      });
  }

  function linesFor(variantId) {
    return ((cartState && cartState.items) || []).filter(function (item) {
      return String(item.variant_id) === String(variantId);
    });
  }

  /* Pieces folded into a combo bundle no longer have their own cart line, so count them by title. */
  function bundledQuantity(title) {
    var bundleId = window.__comboBundleVariantId;
    if (!bundleId || !title) return 0;
    return ((cartState && cartState.items) || []).reduce(function (sum, item) {
      if (String(item.variant_id) !== String(bundleId)) return sum;
      var properties = item.properties || {};
      var pieces = ['Piece 1', 'Piece 2', 'Piece 3'].filter(function (key) {
        return properties[key] === title;
      }).length;
      return sum + pieces * item.quantity;
    }, 0);
  }

  function lineQuantity(variantId) {
    return linesFor(variantId).reduce(function (sum, item) {
      return sum + item.quantity;
    }, 0);
  }

  function sync() {
    document.querySelectorAll('[data-vcard-buy]').forEach(function (buy) {
      var request = pending.get(buy.dataset.variantId);
      var direct = request ? request.desired : lineQuantity(buy.dataset.variantId);
      var quantity = direct + bundledQuantity(buy.dataset.productTitle);
      var add = buy.querySelector('[data-vcard-add]');
      var stepper = buy.querySelector('[data-vcard-qty]');
      var count = buy.querySelector('[data-vcard-count]');
      var inCart = quantity > 0;

      if (add.hidden !== inCart) add.hidden = inCart;
      if (stepper.hidden === inCart) stepper.hidden = !inCart;
      if (count.textContent !== String(quantity)) count.textContent = quantity;
    });
  }

  function showError(card, message) {
    if (!card) return;
    var error = card.querySelector('.vcard__error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'vcard__error';
      error.setAttribute('role', 'alert');
      card.appendChild(error);
    }
    error.textContent = message;
  }

  function clearError(card) {
    var error = card && card.querySelector('.vcard__error');
    if (error) error.remove();
  }

  function renderBubble(sections) {
    var bubble = document.getElementById(BUBBLE_SECTION);
    if (!bubble || !sections || !sections[BUBBLE_SECTION]) return;
    var section = new DOMParser()
      .parseFromString(sections[BUBBLE_SECTION], 'text/html')
      .querySelector('.shopify-section');
    if (section) bubble.innerHTML = section.innerHTML;
  }

  function post(url, body) {
    var config = fetchConfig();
    config.body = JSON.stringify(body);
    return fetch(url, config).then(function (response) {
      return response.json();
    });
  }

  /* A combo needs three pieces, so the bundle check (an extra cart request) is skipped below that. */
  function comboPossible() {
    if (typeof window.applyComboBeforeCartRender !== 'function') return false;
    var bundleId = String(window.__comboBundleVariantId || '');
    var pieces = ((cartState && cartState.items) || []).reduce(function (sum, item) {
      return String(item.variant_id) === bundleId ? sum : sum + item.quantity;
    }, 0);
    return pieces >= 3;
  }

  /* Bring the cart to the quantity shown on the card. Runs one at a time through `queue`. */
  async function flush(variantId) {
    var request = pending.get(variantId);
    if (!request) return;

    /* Clicked before the cart had loaded: the count so far is on top of whatever was already there. */
    if (request.relative) {
      request.desired += lineQuantity(variantId);
      request.relative = false;
    }

    var target = request.desired;
    var notify = request.notify;
    var lines = linesFor(variantId);
    var current = lineQuantity(variantId);
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sectionIds = [BUBBLE_SECTION];
    if (notify && cart) {
      sectionIds = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    try {
      var response = null;

      if (target !== current) {
        if (!lines.length) {
          response = await post(window.routes.cart_add_url, {
            id: variantId,
            quantity: target,
            sections: sectionIds,
            sections_url: window.location.pathname,
          });
        } else {
          var line = lines[lines.length - 1];
          response = await post(window.routes.cart_change_url, {
            id: line.key,
            quantity: Math.max(0, line.quantity + target - current),
            sections: sectionIds,
            sections_url: window.location.pathname,
          });
        }

        if (response.status || response.errors) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: SOURCE,
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          var message = response.description || response.message || response.errors;
          throw new Error(typeof message === 'string' ? message : window.cartStrings.error);
        }

        if (Array.isArray(response.items)) {
          cartState = response;
        } else {
          cartState.items.push(response);
          cartState.item_count += response.quantity;
        }
      }

      var renderState = response;
      var bundled = false;
      if (response && target > current && comboPossible()) {
        renderState = (await window.applyComboBeforeCartRender(response, sectionIds)) || response;
        bundled = renderState !== response;
      }

      if (response) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, productVariantId: variantId, cartData: renderState });
        if (notify && cart && renderState.key) {
          cart.setActiveElement(request.buy.querySelector('[data-vcard-step="1"]'));
          cart.renderContents(renderState);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          renderBubble(renderState.sections);
        }
      }

      /* More clicks may have landed while the request was in flight. */
      var latest = pending.get(variantId);
      if (latest && latest.desired === target) {
        pending.delete(variantId);
      } else if (latest) {
        latest.notify = false;
        enqueue(variantId);
      }

      if (bundled) await fetchCart();
      else sync();
    } catch (error) {
      console.error(error);
      pending.delete(variantId);
      showError(
        request.buy.closest('.vcard'),
        typeof error.message === 'string' && error.message ? error.message : window.cartStrings.error
      );
      await fetchCart();
    }
  }

  function enqueue(variantId) {
    queue = queue.then(function () {
      return flush(variantId);
    });
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-vcard-add], [data-vcard-step]');
    var buy = control && control.closest('[data-vcard-buy]');
    if (!buy) return;
    event.preventDefault();

    var variantId = buy.dataset.variantId;
    var request = pending.get(variantId);
    var isAdd = control.hasAttribute('data-vcard-add');
    var step = isAdd ? 1 : Number(control.dataset.vcardStep);

    if (!request && step < 0 && !linesFor(variantId).length) {
      /* Only present as part of a combo bundle – that is edited from the cart. */
      window.location = window.routes.cart_url;
      return;
    }

    if (!request) {
      request = { desired: lineQuantity(variantId), relative: !cartState, notify: false, buy: buy, timer: null };
      pending.set(variantId, request);
    }
    request.buy = buy;
    request.desired = Math.max(0, request.desired + step);
    if (isAdd) request.notify = true;

    clearError(buy.closest('.vcard'));
    sync();

    /* The first add goes out at once; stepper clicks are grouped into one request. */
    clearTimeout(request.timer);
    if (isAdd) {
      enqueue(variantId);
    } else {
      request.timer = setTimeout(function () {
        enqueue(variantId);
      }, STEP_DELAY);
    }
  });

  /* Cards are re-rendered when filters or sorting change. */
  var syncQueued = false;
  new MutationObserver(function () {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () {
      syncQueued = false;
      sync();
    });
  }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === SOURCE) return;
      fetchCart();
    });
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) fetchCart();
  });

  queue = fetchCart();
})();
